import TSlipbox from './index.vue'

TSlipbox.install = Vue => {
  Vue.component(TSlipbox.name, TSlipbox)
}

export default TSlipbox



// WEBPACK FOOTER //
// ./src/module/slipbox/index.js